module.exports = __webpack_public_path__ + "86f3c3205837085012434069408d8b51.png";